import LaneActiveItem from './lane-active-item';
import LaneOptions from './lane-options';
import LaneAutoscroll from "./lane-auto-scroll";
import LaneInfinityX from "./lane-infinity-x";
import LaneInfinityY from "./lane-infinity-y";
import LaneDraggable from "./lane-draggable";
import LaneItemsClickToCenter from "./lane-items-click-to-center";
import LaneVisibilityObserver from "./lane-visibility-observer";

window.addEventListener('hoContentLoaded', () => {
	Vue.component('ho-lane', {
		mixins: [mixinLifeCycle],
		/**
		 * @property {HTMLElement} lane
		 * @property {HTMLElement} wrapper
		 * @property {number} totalWidth
		 * @property {boolean} showPrev
		 * @property {boolean} showNext
		 * @property {'horizontal'|'vertical'} orientation
		 * @property {boolean} optionInfinity
		 * @property {LaneInfinityX} infinity
		 * @property {number} scrollLeft
		 * @property {'left'|'right'} scrollDirection
		 * @property {boolean} scrollable
		 * @property {boolean} scrollableAllowed
		 * @property {boolean} autoScroll
		 * @property {number} autoScrollSpeed
		 * @property {boolean} autoScrollItemHoverPause
		 * @property {LaneAutoscroll} autoscroll
		 * @property {LaneDraggable} draggable
		 * @property {boolean} itemsClickToCenterEnabled
		 * @property {LaneItemsClickToCenter} itemsClickToCenter
		 * @property {LaneActiveItem} activeItemManager
		 * @property {LaneOptions} optionsParser
		 * @property {LaneVisibilityObserver} visibilityObserver
		 * @property {boolean} autoScrollItemIsPausedMouseOver
		 * @property {boolean} inViewport
		 * @property {'left'|'center'} startPosition
		 * @property {number|null} nextInViewportIndex
		 * @property {'left'|'center'} viewportActiveItemTrigger
		 * @property {HTMLElement[]} childs
		 * @property {number} lastScrollLeft
		 */
		data() {
			return {
				lane: null,
				wrapper: null,
				totalWidth: 0,
				showPrev: false,
				showNext: true,
				orientation: "horizontal",
				optionInfinity: false,
				infinity: null,
				scrollLeft: 0,
				scrollDirection: 'right',
				scrollable: true,
				scrollableAllowed: true,
				autoScroll: false,
				autoScrollSpeed: 5,
				autoScrollReversed : false,
				autoScrollItemHoverPause: false,
				autoscroll: null,
				draggable: null,
				itemsClickToCenterEnabled: false,
				itemsClickToCenter: null,
				activeItemManager: null,
				optionsParser: null,
				visibilityObserver: null,
				autoScrollItemIsPausedMouseOver : false,
				inViewport: false,
				startPosition: 'left',
				nextInViewportIndex : null,
				viewportActiveItemTrigger: 'left',
				childs: [],
				lastScrollLeft: 0,
			};
		},
		computed: {
			current() {
				return this.activeItemManager ? this.activeItemManager.currentActiveIndex + 1 : 0;
			},
			count() {
				return this.childs.length;
			},
			currentScrollPercent() {
				let ret = 0;
				if (this.totalWidth > 0) {
					ret = (this.scrollLeft / this.totalWidth) * 100;
				}
				return ret;
			},
		},
		methods: {
			lifeCycleLock() {
				if (this.autoscroll) {
					this.autoscroll.stopAutoscroll();
				}


				if(this.infinity)
				{
					this.infinity.stopAutoscroll();
				}
			},
			lifeCycleUnlock() {
				if (this.autoscroll && !this.autoscroll.autoScrollStop) {
					this.autoscroll.startAutoscroll();
				}

				if(this.infinity && this.infinity.autoScrollStop)
				{
					this.infinity.startAutoscroll();
				}
			},
			prev() {
				if(this.optionInfinity)
				{
					this.infinity.prev();
				}
				else
				{
					const distance = this.calculateDistance('prev');
					this.scrollTo(this.lane.scrollLeft - distance);
				}
			},
			next() {
				if(this.optionInfinity)
				{
					this.infinity.next();
				}
				else
				{
					const distance = this.calculateDistance('next');
					this.scrollTo(this.lane.scrollLeft + distance);
				}
			},
			calculateDistance(direction) {
				let currentItemIndex = 0;
				let currentScroll = this.lane.scrollLeft;

				let totalWidthUntilCurrentItem = 0;
				for (let i = 0; i < this.childs.length; i++) {
					totalWidthUntilCurrentItem += this.childs[i].offsetWidth;
					if (totalWidthUntilCurrentItem >= currentScroll) {
						currentItemIndex = i;
						break;
					}
				}

				let currentItemWidth = this.childs[currentItemIndex].offsetWidth;
				return currentItemWidth;
			},
			onScroll() {
				const scrollLeft = this.lane.scrollLeft;
				this.scrollDirection = scrollLeft > this.lastScrollLeft ? 'right' : 'left';
				this.lastScrollLeft = scrollLeft;

				this.update();
			},
			onResize() {
				this.totalWidth = Array.from(this.lane.children).reduce(
					(acc, child) => acc + child.offsetWidth,
					0
				);
				this.update();
			},
			updateButtons() {
				if(this.optionInfinity)
				{
					this.showPrev = true;
					this.showNext = true;
					return;
				}
				const laneWidth = this.lane.clientWidth;

				if (this.totalWidth <= laneWidth) {
					this.showPrev = false;
					this.showNext = false;
					this.scrollable = false;
				} else {
					this.showPrev = this.lane.scrollLeft > 0;
					this.showNext = this.lane.scrollLeft < this.totalWidth - laneWidth;
					if (this.scrollableAllowed) this.scrollable = true;
				}
			},
			scrollTo(position) {
				gsap.to(this.lane, {
					scrollTo: {
						x: position,
						autoKill: true,
					},
					duration: 1.3,
					ease: 'expo.out',
					onStart: this.start,
					onComplete: this.complete,
				});
			},
			start() {
				this.lane.classList.add('is-animating');
			},
			complete() {
				this.lane.classList.remove('is-animating');
				this.update();
			},
			update() {
				this.updateButtons();
				this.updateVisibleItems();

				if (this.activeItemManager) {
					this.activeItemManager.updateActiveItem();
				}
			},
			updateVisibleItems() {

				const laneScrollLeft = this.lane.scrollLeft;
				const laneScrollRight = laneScrollLeft + this.lane.clientWidth;
				let minDistance = Infinity;
				let nextInViewportIndex = null;

				this.childs.forEach((child, index) => {
					const childLeft = child.offsetLeft;
					const childRight = childLeft + child.offsetWidth;

					const isInViewport =
						childRight > laneScrollLeft && childLeft < laneScrollRight;

					if (isInViewport) {
						child.classList.add('ho-lane-in-viewport');
					} else {
						child.classList.remove('ho-lane-in-viewport');

						let distance = Infinity;
						if (this.scrollDirection === 'right' && childLeft >= laneScrollRight) {
							distance = childLeft - laneScrollRight;
						} else if (
							this.scrollDirection === 'left' &&
							childRight <= laneScrollLeft
						) {
							distance = laneScrollLeft - childRight;
						}

						if (distance < minDistance) {
							minDistance = distance;
							nextInViewportIndex = index;
						}
					}
				});

				if (this.nextInViewportIndex !== null && this.nextInViewportIndex !== nextInViewportIndex) {
					this.childs[this.nextInViewportIndex].classList.remove('ho-lane-item-next-in-viewport');
				}

				if (nextInViewportIndex !== null && nextInViewportIndex !== this.nextInViewportIndex) {
					this.childs[nextInViewportIndex].classList.add('ho-lane-item-next-in-viewport');
				}

				this.nextInViewportIndex = nextInViewportIndex;
			},
		},
		beforeDestroy() {
			this.lane.removeEventListener('scroll', this.onScroll);
			window.removeEventListener('resize', this.onResize);

			if (this.draggable) {
				this.draggable.destroy();
			}

			if (this.visibilityObserver) {
				this.visibilityObserver.disconnect();
			}

			if (this.autoscroll) {
				this.autoscroll.stopAutoscroll();
			}

			if(this.infinity)
				this.infinity.destroy();

			if (this.itemsClickToCenter) {
				this.itemsClickToCenter.destroy();
			}
		},
		mounted() {
			this.lane = this.$el.querySelector('.wp-block-ho-lane');
			this.childs = this.$el.querySelectorAll('.wp-block-ho-lane-item');
			this.wrapper = this.$el.querySelector('.wp-block-ho-lane-wrapper');

			this.totalWidth = Array.from(this.lane.children).reduce(
				(acc, child) => acc + child.offsetWidth,
				0
			);

			this.optionsParser = new LaneOptions(this);

			if(this.optionInfinity)
			{
				if(this.orientation === "horizontal")
				{
					this.infinity = new LaneInfinityX(this);
					this.updateButtons();
				}
				else
				{
					this.infinity = new LaneInfinityY(this);
					this.updateButtons();
				}
			}
			else
			{
				this.lastScrollLeft = this.lane.scrollLeft;
				this.lane.addEventListener('scroll', this.onScroll);
				window.addEventListener('resize', this.onResize);

				if (this.scrollableAllowed) {
					this.draggable = new LaneDraggable(this);
				}

				if (this.autoScroll) {
					this.autoscroll = new LaneAutoscroll(this);
					this.autoscroll.startAutoscroll();
				}

				if (this.itemsClickToCenterEnabled) {
					this.itemsClickToCenter = new LaneItemsClickToCenter(this);
				}

				// Initialize visibility observer
				this.visibilityObserver = new LaneVisibilityObserver(this);

				// Initialize active item manager
				this.activeItemManager = new LaneActiveItem(this);

				Vue.nextTick(() => {
					this.lastScrollLeft = this.lane.scrollLeft;
					this.update();
				});
			}
		},
	});
});
